import { cn } from "@/lib/utils";

export function EvidenceChip({ id, className, ...rest }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-mono border border-slate-200 bg-slate-50 text-slate-700 rounded-sm",
        className
      )}
      title={id}
      {...rest}
    >
      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M9 12l2 2 4-4"/><circle cx="12" cy="12" r="10"/>
      </svg>
      {id.length > 14 ? `${id.slice(0, 8)}…${id.slice(-4)}` : id}
    </span>
  );
}

export function HashChip({ hash, prevHash }) {
  if (!hash) return null;
  return (
    <div className="inline-flex items-center gap-2 text-[10px] font-mono text-slate-500">
      <span className="text-emerald-700">sha256</span>
      <code className="px-1.5 py-0.5 bg-slate-50 border border-slate-200 rounded-sm text-slate-700">
        {hash.slice(0, 10)}…{hash.slice(-6)}
      </code>
      {prevHash && (
        <>
          <span className="text-slate-400">←</span>
          <code className="px-1.5 py-0.5 bg-slate-50 border border-slate-200 rounded-sm text-slate-500">
            {prevHash.slice(0, 8)}…
          </code>
        </>
      )}
    </div>
  );
}
